import { format, parseISO } from "date-fns";

export const dateStringFormatType = {
  display: "yyyy/MM",
  inputMonth: "yyyy-MM",
  displayDate: "yyyy/MM/dd",
  inputDate: "yyyy-MM-dd",
  displayDateUser: "yyyy/MM/dd HH:mm:ss",
} as const;
export type DateStringFormatType =
  (typeof dateStringFormatType)[keyof typeof dateStringFormatType];

export const dateToString = (
  date: Date,
  formatType: DateStringFormatType = "yyyy-MM-dd",
) => {
  return format(new Date(date), formatType);
};

export const stringToDate = (date: string) => {
  return parseISO(date);
};

export const birthdayToAge = (birthday: Date) => {
  const targetBirthday = new Date(birthday);
  const today = new Date();
  const age = today.getFullYear() - targetBirthday.getFullYear();

  const thisYearBirthday = new Date(
    today.getFullYear(),
    targetBirthday.getMonth(),
    targetBirthday.getDate(),
  );

  return today < thisYearBirthday ? age - 1 : age;
};
